// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"624":"b7b7b45a","850":"3bc8086a"}[chunkId] + ".chunk.css";
};